import client from '../../providers/fetchClient'

export const getCampaignResponse = id => client.get(`/v3/bmp/campaign-response/${id}`)

export const getOperationCode = campaign_id => client.get(`/v3/bmp/operation-code/${campaign_id}`)
